<!-- src/components/Note/BatchDeleteNoteForm.vue -->
<script setup>
  import { computed, ref } from "vue";
  import { useNoteStore } from "@/stores/useNoteStore";
  import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";
  
  const emit = defineEmits(["close"]);
  const noteStore = useNoteStore();
  
  // ✅ congela a contagem no momento em que o modal é criado/aberto
  const frozenCount = ref(noteStore.selectedNoteIds.length);
  
  const messageTitle = computed(() => {
    if (frozenCount.value > 1) {
      return `Tem certeza que deseja excluir ${frozenCount.value} notas?`;
    }
    return "Tem certeza que deseja excluir esta nota?";
  });
  
  const messageSubtitle = computed(() => {
    return (
      "Esta ação não pode ser desfeita."
      
    );
  });
  
  // ===============================
  // ✅ Tratamento de erro específico (lote)
  // ===============================
  function buildBatchNoteDeleteError(error) {
    const raw = error?.response?.data?.message || error?.response?.data || error?.message || "";
  
    // Fallback honesto (sem inventar FK específica, porque pode variar)
    const defaultMessage =
      "Não foi possível excluir as notas selecionadas.\n" +
      "Alguma delas pode estar vinculada a dados que impedem a remoção.";
  
    // Normaliza alguns casos comuns
    if (typeof raw === "string") {
      // MySQL / MariaDB FK padrão
      if (raw.toLowerCase().includes("foreign key constraint fails")) {
        return (
          "Uma ou mais notas selecionadas possuem vínculos que impedem a exclusão.\n" +
          "Remova primeiro os registros relacionados a essas notas e tente novamente."
        );
      }
  
      // Erro genérico do seu backend
      if (raw.toLowerCase().includes("cannot delete") || raw.toLowerCase().includes("cannot remove")) {
        return raw;
      }
  
      return raw || defaultMessage;
    }
  
    return defaultMessage;
  }
  
  // ===========================================
  // ✅ onConfirm: executa e deixa o modal cuidar
  // ===========================================
  async function onConfirmBatchDelete() {
    try {
      await noteStore.deleteSelectedNotes();
      noteStore.shouldForcePageOne = true;
    } catch (error) {
      throw new Error(buildBatchNoteDeleteError(error));
    }
  }
  </script>
  
  <template>
    <DeleteConfirmModal
      :show="true"
      title="Apagar Notas em Lote"
      :messageTitle="messageTitle"
      :messageSubtitle="messageSubtitle"
      confirmText="Sim, apagar"
      cancelText="Cancelar"
      loadingText="Apagando..."
      :onConfirm="onConfirmBatchDelete"
      :hideModalOnSuccess="true"
      @close="emit('close')"
    />
  </template>
  